import type { MutableRefObject } from 'react';
import type { CarouselAPI } from '@elfsight/lib-carousel';
import type { LayoutAPI } from '../types';

export const createCarouselAPI = (
  carouselRefAPI: MutableRefObject<CarouselAPI | null>,
  layoutAPI: LayoutAPI
) => ({
  get currentItemIndex() {
    return carouselRefAPI.current?.currentItemIndex ?? 0;
  },
  get visibleItemsIndexes() {
    return carouselRefAPI.current?.visibleItemsIndexes ?? [];
  },
  get hasPrevious() {
    return carouselRefAPI.current?.hasPrevious ?? false;
  },
  get hasNext() {
    return carouselRefAPI.current?.hasNext ?? false;
  },
  slideTo(itemIndex: number, speed?: number) {
    carouselRefAPI.current?.slideTo(itemIndex, speed);
  },
  slideToNext() {
    carouselRefAPI.current?.slideToNext();
  },
  slideToPrevious() {
    carouselRefAPI.current?.slideToPrevious();
  },
  rerender() {
    carouselRefAPI.current?.rerender();
  },
  autoplayStart() {
    carouselRefAPI.current?.autoplayStart();
  },
  autoplayStop() {
    carouselRefAPI.current?.autoplayStop();
  },
  autoplayIsRunning() {
    return carouselRefAPI.current?.autoplayIsRunning() ?? false;
  },
  updateAutoHeight() {
    carouselRefAPI.current?.updateAutoHeight();
  },
  ...layoutAPI
});
